// Shared destination rules for registration, normal login and invitation continuation.
const appOrigin = () => (typeof window !== 'undefined' ? window.location.origin : 'https://app.markbase.ru');

export const isSafeReturnUrl = (value) => {
  if (typeof value !== 'string' || !value || /[\\\u0000-\u0020\u007f]/.test(value)) return false;
  if (value.startsWith('/')) return !value.startsWith('//');
  try {
    const parsed = new URL(value);
    if (parsed.username || parsed.password) return false;
    if (parsed.origin === appOrigin()) return true;
    return parsed.protocol === 'https:'
      && (parsed.hostname === 'markbase.ru' || parsed.hostname.endsWith('.markbase.ru'));
  } catch (_) {
    return false;
  }
};

export const buildRedirectTarget = (path, fallback = '/dashboard') => {
  const raw = typeof path === 'string' && path ? path : fallback;
  const candidate = raw && !raw.startsWith('/') && !/^[a-z][a-z0-9+.-]*:/i.test(raw) ? '/' + raw : raw;
  return isSafeReturnUrl(candidate)
    ? new URL(candidate, appOrigin()).href
    : appOrigin() + '/dashboard';
};

export const resolvePostAuthTarget = (authState = {}, requestedTarget) => {
  let target = buildRedirectTarget(requestedTarget);
  const parsed = new URL(target);
  if (
    parsed.pathname === '/' || parsed.pathname === '/login' || parsed.pathname === '/register'
    || parsed.pathname === '/auth' || parsed.pathname.startsWith('/auth/')
    || parsed.hostname === 'auth.markbase.ru'
  ) {
    target = buildRedirectTarget('/dashboard');
  }

  // The protected destination offers a retry until the server context is known.
  if (authState.bootstrapStatus && authState.bootstrapStatus !== 'ready') {
    return buildRedirectTarget('/dashboard');
  }

  if (authState.user?.id && !authState.company?.id) {
    const destination = new URL(target);
    const setupPaths = ['/company/create', '/company/join', '/company/requests'];
    if (destination.origin === appOrigin() && setupPaths.includes(destination.pathname)) return target;
    return buildRedirectTarget('/company/create');
  }
  return target;
};
